/**
 * Artistic dials for the outdoors. Every value is a multiplier (or a plain amount) on what the sky table in `day-cycle.ts`
 * and the lighting rig already produce, so the defaults reproduce the shipped look exactly and the game never needs to change them.
 * The scenario viewer's settings Tuning tab edits this one object live; "Copy values" prints it so the result can be
 * pasted into `DEFAULT_TUNING` below. Nothing here is read from the network or storage in a production entry point.
 */
export interface GraphicsTuning {
  /** Tone-mapping exposure multiplier: overall brightness. */
  exposure: number;
  /** Key light (sun by day, moon by night). */
  sun: number;
  /** Sky and ground bounce (hemisphere light). */
  ambient: number;
  /** Violet shadow-side fill, and the sea-light rim. */
  fill: number; rim: number;
  /** How much of the sky metal, wet ground and smooth surfaces reflect (it also adds a little sky light to everything). */
  reflections: number;
  /** Fog start and end distance multiplier: higher sees farther. */
  fogDistance: number;
  /** Shadow edge blur in shadow-map texels (PCF). */
  shadowSoftness: number;
  /** Shadow depth bias; raise it if shadows crawl or striping appears, lower it if they detach from their casters. */
  shadowNormalBias: number;
  /** How vivid and how light the land palettes are. Baked in when a scene is built: change, then rebuild the scene. */
  landSaturation: number; landLightness: number;
}

export const DEFAULT_TUNING: Readonly<GraphicsTuning> = {
  exposure: 1, sun: 1.49, ambient: 1.51, fill: 1.5, rim: 0, reflections: .3, fogDistance: .63, shadowSoftness: 2, shadowNormalBias: 0,
  landSaturation: .9, landLightness: .9,
};

export const TUNING: GraphicsTuning = { ...DEFAULT_TUNING };
